import { actionCopyDe } from "./actionCopy";

export const inviteCopyDe = {
    reviewSetup: "Einrichtung prüfen",
    organisationAndContact: "Organisation und Kontakt",
    addPatient: "Patient hinzufügen",
    inviteByEmail: "Per E-Mail einladen",
    shareQrCode: "Link / QR-Code teilen",
    inviteSent: "Einladung gesendet",
    inviteSentTo: (email) => `Einladung an ${email} gesendet`,
    loading: actionCopyDe.loading,
    justAMoment: "Einen Moment bitte...",
    patientEmailWillReceiveInstructions: (email) => `${email} erhält eine E-Mail mit Anweisungen zum Einstieg.`,
    patientPhoneWillReceiveInstructions: (phone) => `${phone} erhält eine SMS mit Anweisungen zum Einstieg.`,
    patientWillReceiveInstructions: "Ihr Patient erhält eine E-Mail mit Anweisungen zum Einstieg.",
    emailAndMobileHint: "Beides, wenn möglich.",
    emailOrPhoneRequired: "(oder Telefon erforderlich)",
    mobileOrEmailRequired: "(oder E-Mail erforderlich)",
    diariesAddedInLast7Days: (count) =>
        `In den letzten 7 Tagen haben Sie ${count} Tagebücher zu Patient Watch hinzugefügt.`,
    goToDiary: "Zum Tagebuch",
    inviteAnotherPatient: "Weiteren Patienten einladen",
    whatWasInjected: "Was wurde injiziert",
    clinicians: "Behandler",
    referringClinician: "Überweisender Behandler",
    injectingClinician: "Injizierender Behandler",
    operatingSurgeon: "Operierender Chirurg",
    therapist: "Therapeut",
    injectionMethod: "Injektionsmethode",
    questionnaires: "Fragebögen",
    clinicContact: "Klinikkontakt",
    surgeryDetails: "Operationsdetails",
    injectionDetails: "Injektionsdetails",
    treatmentDetails: "Behandlungsdetails",
    consultationDetails: "Beratungsdetails",
    consultationName: "Beratungsname",
    description: "Beschreibung",
    clinician: "Behandler",
    consultingClinician: "Beratender Behandler",
    consultingClinicianDescription: "Der Behandler, der die Beratung durchgeführt hat",
    productDetails: "Produktdetails",
    providingClinician: "Bereitstellender Behandler",
    providingClinicianDescription: "Der Behandler, der das Produkt verschrieben, ausgegeben oder eingerichtet hat",
    usageInstructions: "Anwendungshinweise",
    editInjectionDetails: "Injektionsdetails bearbeiten",
    editInjectionClinicians: "Injektions-Behandler bearbeiten",
    editSurgeryDetails: "Operationsdetails bearbeiten",
    editSurgeryClinicians: "Operations-Behandler bearbeiten",
    editShockwaveDetails: "Stoßwellendetails bearbeiten",
    editShockwaveClinicians: "Stoßwellen-Behandler bearbeiten",
    editConsultationDetails: "Beratungsdetails bearbeiten",
    editConsultingClinician: "Beratenden Behandler bearbeiten",
    editProductDetails: "Produktdetails bearbeiten",
    editProvidingClinician: "Bereitstellenden Behandler bearbeiten",
    editClinicContact: "Klinikkontakt bearbeiten",
    notSet: "Nicht gesetzt",
    selected: "Ausgewählt",
    unknownForm: "Unbekanntes Formular",
    unknownSchedule: "Unbekannter Zeitplan",
    noSide: "Keine Seite",
    noOptionSelected: "Keine Option ausgewählt",
    noSubstanceSelected: "Keine Substanz ausgewählt",
    noSiteSelected: "Keine Seite oder Region ausgewählt",
    email: "E-Mail",
    enterEmail: "E-Mail eingeben",
    titleOptional: "Anrede (optional)",
    firstNameOptional: "Vorname (optional)",
    lastNameOptional: "Nachname (optional)",
    mobileNumber: "Mobilnummer",
    firstNamePlaceholder: "z. B. Sherlock",
    lastNamePlaceholder: "z. B. Holmes",
    selectPlaceholder: "Auswählen",
    sendInvite: "Einladung senden",
    sendingInvite: "Einladung wird gesendet…",
    inviteSentToast: "Einladung gesendet",
    existingPatient: "Bestehender Patient",
    existingPatientAddDiary: "Wir fügen dieses Tagebuch dem bestehenden Konto hinzu.",
    existingUser: "Bestehender Benutzer",
    existingUserAddToOrganisation: "Wir fügen die Person dieser Organisation hinzu, statt ein neues Konto anzulegen.",
    existingSecretary: "Bestehender Sekretär",
    existingSecretaryAddAsYours:
        "Wir fügen die Person als Ihre Sekretärin oder Ihren Sekretär für diese Organisation hinzu.",
    diaryQuotaBlockedTitle: "Tagebuch-Limit erreicht",
    diaryQuotaUsage: (used: number, limit: number) =>
        `Sie haben in diesem Abrechnungszeitraum ${used} von ${limit} Tagebüchern genutzt.`,
    diaryQuotaBlockedDescription: "Upgraden Sie Ihren Plan, um weitere Patienten mit Tagebuch einladen zu können.",
    diaryQuotaUpgradeCta: "Plan wählen",
    diaryQuotaOwnerUnresolved:
        "Es konnte nicht ermittelt werden, welches Tagebuch-Kontingent gilt. Verknüpfen Sie diese Sekretärskraft mit einem Behandler, oder laden Sie als dieser Behandler ein.",
    noTemplateSelected: "Keine Vorlage ausgewählt. Bitte",
    createTemplate: "Vorlage erstellen",
    createTemplateFirst: "Sie zuerst.",
    organisation: "Organisation",
    hospitalNumberOptional: "Krankenhausnummer (optional)",
    enterNhsHospitalNumber: "NHS-Krankenhausnummer eingeben",
    hospitalNumberDescription: "Hilft, diesen Patienten in Ihren Krankenhausunterlagen zuzuordnen.",
    referenceDateLabel: "Datum, ab dem gezählt wird",
    referenceDateStartToday: "Ab heute",
    referenceDateAskPatient: "Patient teilt es mit",
    inviteMethodLabel: "Wie der Patient seine Einladung erhält",
    inviteMethodSend: "E-Mail oder SMS senden",
    inviteMethodShare: "QR-Code zeigen oder Link kopieren",
    selectOrganisationToContinue: "Wählen Sie eine Organisation, um fortzufahren.",
    selectContactToContinue: "Wählen Sie eine Kontaktperson, um fortzufahren.",
    doctorEmailSharedWithPatient:
        "Diese E-Mail wird mit dem Patienten geteilt. Seien Sie vorsichtig, wenn Sie sie weitergeben oder hier verwenden.",
    currentUserEmailSharedWithPatient:
        "Ihre E-Mail wird mit Patienten geteilt und in deren Mitteilungen in Kopie gesetzt. Wir empfehlen, eine allgemeine Hilfe-E-Mail, etwa ein Abteilungspostfach, als Kontaktperson hinzuzufügen.",
    addContactPerson: "Person hinzufügen",
    personalContactEmailWarning: "Das sieht nach einer persönlichen E-Mail-Adresse aus, und Patienten sehen sie.",
    personalContactEmailAddContact: "Fügen Sie einen allgemeinen Kontakt",
    personalContactEmailAfterLink: "wie info@clinic.com über die Team-Seite hinzu - das ist kostenlos.",
    enterPhoneNumber: "Telefonnummer eingeben",
    backToSetup: "Zurück zur Einrichtung",
    backToPatients: "Zurück zu den Patienten",
    patientInvite: "Patienteneinladung",
    diaryQrCode: "Tagebuch-QR-Code",
    diaryQrDescription:
        "Teilen Sie diesen QR-Code oder Link, damit Patienten sich auf ihrem Telefon anmelden und dieses Tagebuch starten können. Die Einrichtungsdetails wurden im vorherigen Schritt bestätigt.",
    generatingInviteLink: "Einladungslink wird erstellt…",
    failedToCreateInviteLink: "Einladungslink konnte nicht erstellt werden",
    hospitalOnTheInvite: "Krankenhaus auf der Einladung",
    changingOrganisationUpdatesLink: "Eine Änderung aktualisiert den Link und den QR-Code.",
    shownOnPatientSignupLink: "Wird im Anmeldelink für Patienten angezeigt.",
    patientWillChooseOrganisation: "Der Patient wählt seine Organisation bei der Anmeldung.",
    hospitalNumber: "Krankenhausnummer",
    enterHospitalNumber: "Krankenhausnummer eingeben",
    requiredForNhsOrganisations: "Wird für Organisationen angezeigt, die eine Krankenhausnummer erfassen",
    copyLink: "Link kopieren",
    copyQrCode: "QR-Code kopieren",
    copyInviteLink: "Einladungslink kopieren",
    invitePageTitle: "Einladen",
    roleAndOrganisation: "Rolle und Organisation",
    navInviteDescription: "Laden Sie einen Behandler, Patienten oder Mitarbeiter zu Patient Watch ein.",
    tabEmail: "E-Mail",
    tabQrCode: "QR-Code",
    optionalSuffix: "(optional)",
};
